import Service from "../../../Services/index";

const Sheet = {
    namespaced: true,
    state: {
        table: [],
        sheet_type: [],
        sheet_all: [],
        form: {
            code: "",
            name: "",
            sheet_type: null,
            quantity: 0,
            length: "",
            width: "",
            weight: "",
            diameter: "",
            thickness: "",
            border: "",
            onSave: false,
            name_th: '',
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search: {
            code: ""
        },
    },
    mutations: {
        GET_SHEET_ALL: (state, data) => {
            state.sheet_all = data;
        },
        GET_SHEET: (state, res) => {
            state.table = res.data
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_SHEET_TYPE: (state, data) => {
            state.sheet_type = data;
        },
        SET_FORM_SHEET: (state, res) => {
            state.form = res;
        },
        CLEAR_FORM_DATA: state => {
            state.form = {
                code: "",
                name: "",
                sheet_type: null,
                quantity: 0,
                length: "",
                width: "",
                weight: "",
                diameter: "",
                thickness: "",
                border: "",
                onSave: false,
                name_th: '',
            };
        },
        CLEAR_SEARCH: state => {
            state.search = {
                code: ""
            }
        }
    },
    actions: {
        get({commit}, page = 1) {
            return Service.Sheet.getSheet(page)
                .then(response => {
                    commit("GET_SHEET", response);
                })
                .catch(err => {
                    //console.log(err);
                });
        },
        show({commit}, id) {
            return Service.Sheet.showSheet(id)
                .then(response => {
                    commit("SET_FORM_SHEET", response);
                })
                .catch(err => {
                    //console.log(err);
                });
        },
        save({commit, state}, id) {
            const data = {
                code: state.form.code,
                name: state.form.name,
                sheet_type_id: state.form.sheet_type.id,
                quantity: state.form.quantity,
                length: state.form.length,
                width: state.form.width,
                weight: state.form.weight,
                diameter: state.form.diameter,
                thickness: state.form.thickness,
                border: state.form.border,
                name_th: state.form.name_th,
            };
            //console.log(data);
            if (!id) {
                return Service.Sheet.createSheet(data)
            } else {
                return Service.Sheet.updateSheet(id, data)
            }
        },
        delete({commit}, id) {
            return Service.Sheet.deleteSheet(id)
        },
        search({commit}, {page = "", code}) {
            return Service.Sheet.searchSheet(page, code).then(response => {
                commit("GET_SHEET", response);
            });
        },
        getSheetTYPE({commit}) {
            return Service.Sheet.getSheetType().then(data => {
                commit("GET_SHEET_TYPE", data);
            });
        },
        clearFormData({commit}) {
            commit("CLEAR_FORM_DATA");
        },
        getAll({commit}) {
            return Service.Sheet.getAllSheet().then(data => {
                commit("GET_SHEET_ALL", data);
            });
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        saveSheetType({commit}, data) {
            if (data.id) {
                return Service.Sheet.updateSheetType(data);
            } else {
                return Service.Sheet.createSheetType(data);
            }
        },
    }
};

export default Sheet;
